export default __webpack_public_path__ + "static/media/main_info_data_01.dbf0aba8.png";